// NewCategory.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import './NewCategory.css';
import { baseUrl } from '../components/constant';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Ensure toastify styles are imported

const NewBrand = () => {
  const [name, setName] = useState('');
  const [NameAr, setNameAr] = useState('');
  
  const [imageUrl, setImageUrl] = useState('');
  const [newImage, setNewImage] = useState(null);
  const [NewImageView, setNewImageView] = useState(null);
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const navigate = useNavigate();




  const handleSave = async (e) => {
    e.preventDefault();
    setError('')
    if (!name) {
      toast.error('Please enter english brand name.');
      return;
    }
    if (!NameAr) {
      toast.error('Please enter arabic brand name.');
      return;
    }
  
    setLoading(true);

    try {
      const token = JSON.parse(localStorage.getItem('token'));
      if (!token) {
        toast.error('You are not authenticated.');
        return;
      }
      const nameObj = {
        en: name,
        ar: NameAr,
      };
      const formData = new FormData();
      // formData.append('name', JSON.stringify(nameObj));
      console.log("formData",formData)
      const response = await fetch(baseUrl + '/categories/brands', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Set Content-Type to application/json
          'Accept': 'application/json',
          "Authorization": 'Bearer ' + token,
        },
        body: JSON.stringify({ name: nameObj }),
      });

      const data = await response.json();
      console.log("data",data)
      if (response.ok) {
        toast.success('added successfully');
        navigate('/Brand');// Redirect to the home page within the root layout
      } else {
        if (data.errors) {
          if (data.errors.name) {
            toast.error(data.errors.name[0]);
          }
        }
      }
    } catch (err) {
      console.log("err", err)
      // Handle network or unexpected errors
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

 
  return (
    <div style={{ width: '100%' }}>
      {loading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}


      <h2 style={{ color: "#000", textAlign: 'center' }}>New Brand</h2>
      <div className="new-category-container">
        <div className="new-category">
          <div className="new-form-group">
            <label htmlFor="name">English Name</label>
            <input
              style={{ backgroundColor: "#fff", fontSize: 20, width: "70%", color: "#000" }}
              placeholder='english brand name'
              required
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="new-form-group">
            <label htmlFor="name">Arabic Name</label>
            <input
              style={{ backgroundColor: "#fff", fontSize: 20, width: "70%", color: "#000" }}
              placeholder='arabic brand name'
              required
              type="text"
              id="namear"
              value={NameAr}
              onChange={(e) => setNameAr(e.target.value)}
            />
          </div>
        
          <div className="form-buttons">
            <button onClick={handleSave} style={{ backgroundColor: "rgb(154, 57, 57)" }}>Save</button>
            <button onClick={() => navigate('/Brand')} style={{ backgroundColor: "#000" }}>Cancel</button>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default NewBrand;
